import { createFrost } from '../vendor/canvasui/Frost/FrostVanilla.js';

const initFooterFrost = () => {
  document.querySelectorAll('.js-footer-frost').forEach((wrapper) => {
    if (wrapper.dataset.frostInitialized === 'true') return;

    const footer = wrapper.closest('.main-footer');
    const source = wrapper.querySelector('.main-footer__frost-source');
    const content = wrapper.querySelector('.main-footer__frost-content');
    const output = wrapper.querySelector('.main-footer__frost-output');
    if (!footer || !source || !content || !output) return;

    const frost = createFrost({ source, content, output }, {
      strength: 0.34,
      contrast: 1.3,
      crispness: 0.55,
      highlight: 0.12,
      haze: 0.55,
      tintStrength: 0.27,
      tintThin: [0.6, 0.737, 0.824],
      tintThick: [0.78, 0.86, 0.91],
      saturation: 0.94,
      brightness: 0.97,
      refraction: 0.45,
      detail: 0.9,
      textureScale: 3,
      meltNoise: 0.3,
      opacity: 0.27,
      quality: 0.7,
    });

    if (!frost) return;

    let pointerFrame = 0;
    let pointerPosition = null;
    footer.addEventListener('pointermove', (event) => {
      const rect = footer.getBoundingClientRect();
      pointerPosition = [
        (event.clientX - rect.left) / Math.max(rect.width, 1),
        (event.clientY - rect.top) / Math.max(rect.height, 1),
      ];
      if (pointerFrame) return;
      pointerFrame = window.requestAnimationFrame(() => {
        pointerFrame = 0;
        if (pointerPosition) frost.melt(...pointerPosition);
      });
    }, { passive: true });

    wrapper.classList.add('is-ready');
    wrapper.dataset.frostInitialized = 'true';
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFooterFrost);
} else {
  initFooterFrost();
}
